// external imports
import React from 'react'
import Helmet from 'react-helmet'
// local imports
import { Text } from '~/components'
import styles from './styles'
import {FlexColumn} from 'quark-web'
import { DangerousChangeType } from 'graphql'
import './responsive.css' // responsive layout styling only

const Button = ({ onClick, children, as: Component = 'button', ...rest }) => {
    return (
      <Component onClick={onClick} style={styles.button} {...rest}>
        {children}
      </Component>
    );
  };

const Splash = () => (
    <>
        <Helmet title="Home" />

        <div style = {Object.assign({}, styles.container, styles.tomatoBG)}>
            <div style = {styles.overlay}>
                <FlexColumn
                className = 'leftAlign'
                style = {styles.content}>
                    <Text style = {styles.header}>{`Lark Seeds \nInternational`}</Text>
                    <Text className = 'description' style = {styles.description}>{`provides innovative agricultural solutions to growers in the vegetable seed industry. We are dedicated to cutting-edge research and development of premium hybrids. We specialize in breeding, marketing, and distribution of premium seed varieties for the global market.`}</Text>
                </FlexColumn>
            </div>
        </div>

        <div style = {Object.assign({}, styles.container, styles.redPepperBG)}>
            <div style = {styles.overlayDark}>
                <FlexColumn
                 style = {styles.subcontent}>
                    <Text style = {styles.header}>{`OUR MISSION`}</Text>
                    <Text className = 'description' style = {styles.description}>{`Our core mission is to mitigate the risk of our growers and unleash value through innovative tools that have a sound impact all the way to the consumer level.`}</Text>
                    <a href="/company" style = {{margin: '10', borderRadius: 100}}>
                        <button style = {styles.button}>{`COMPANY >`}</button>
                    </a>
                </FlexColumn>
            </div>
        </div>

        <div style = {Object.assign({}, styles.container, styles.greenPepperBG)}>
            <div style = {styles.overlayDark}>
                <FlexColumn
                style = {styles.subcontent}>
                    <Text style = {styles.header}>{`OUR PRODUCTS`}</Text>
                    <Text className = 'description' style = {styles.description}>{`Our product line offers a wide variety of premium hybrid vegetables seeds that deliver above-average quality with higher yield and disease resistances.`}</Text>
                    <a href="/products" style = {{margin: '10', borderRadius: 100}}>
                        <button style = {styles.button}>{`ALL PRODUCTS >`}</button>
                    </a>
                </FlexColumn>
            </div>
        </div>
    </>
)

export default Splash



// WEBPACK FOOTER //
// ./src/views/Splash/index.js